/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:a8958f4b-2a07-4b94-af0e-228fe5d9b920",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_m48IlWyFP",
    "aws_user_pools_web_client_id": "356qr153mgbm8fdaos4q2v8gm8",
    "oauth": {},
    "aws_cognito_login_mechanisms": [
        "PREFERRED_USERNAME"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://4tncmy6lhbarlpxmvfneajpgya.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-fakeApiId123456",
    "aws_user_files_s3_bucket": "fixera86c74aa95514447aacd8916fb66f96524048-demo",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
